document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.announcement-swiper', {
        loop: false,
        autoplay: {
            delay: 4000,
        },
        slidesPerView: 3,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                simulateTouch: true,
            }
        }
    });
});